{
  "dss": {
    "button": {
      "back": "Назад",
      "cancel": "Откажи",
      "close": "Затвори",
      "confirmDelete": "Да, избриши",
      "continue": "Продолжи",
      "logout": "Одјава",
      "passwordReset": "Ресетирање на лозинка",
      "save": "Зачувај",
      "verify": "Потврди"
    },
    "error": {
      "403": "Немате пристап до оваа страница.",
      "404": "Оваа страница не постои.",
      "generic": "Се појави грешка. Ве молиме обидете се повторно подоцна.",
      "invalidConfirmationLink": "Линкот за потврда е истечен или неважечки.",
      "throttling": "Премногу обиди. Оваа операција е привремено блокирана.",
      "title": "Грешка",
      "title403": "Забранет пристап",
      "title404": "Не е пронајдено"
    },
    "footer": {
      "imprint": "Импресум",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "Политика за приватност",
      "terms": "Услови на користење"
    },
    "label": {
      "CRMAccountNumber": "CRM број на сметка",
      "contact": "Контакт",
      "email": "Е-пошта",
      "faq": "ЧПП",
      "female": "Г-ѓа",
      "firstname": "Име",
      "help": "Помош",
      "language": "Јазик",
      "lastname": "Презиме",
      "male": "Г-дин",
      "needHelp": "Ви треба помош?",
      "newPassword": "Нова лозинка",
      "newPassword2": "Потврдете нова лозинка",
      "oldPassword": "Тековна лозинка",
      "organization": "Организација",
      "password": "Лозинка",
      "required": "задолжително",
      "salutation": "Обраќање",
      "select": "Ве молиме изберете"
    },
    "lang": {
      "de": "Германски"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Потврдете регистрација",
        "wait": "Ве молиме почекајте додека се заврши потврдата на сметката."
      },
      "otp": {
        "btnResend": "Прати го кодот за потврда повторно",
        "msg": {
          "invalidOTP": "Внесената еднократна лозинка не е валидна.",
          "resendFail": "Неуспешно повторно праќање на кодот. Обидете се подоцна."
        },
        "spamDetail": "Проверете го сандачето и спам-папката за е-пошта од STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Не добивте е-пошта?",
        "subtitle": "За да продолжите, треба да ја потврдите вашата е-пошта.",
        "title": "Потврдете го вашиот кориснички профил",
        "txtVerifyMail": "Внесете го новиот код за потврда што го испративме на вашата е-пошта {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Нема што да се ажурира.",
          "updateError": "Неуспешно ажурирање на личните податоци.",
          "updated": "Личните податоци се ажурирани.",
          "userLoadErr": "Настана грешка при вчитување на кориснички податоци. Обидете се подоцна."
        },
        "secOrganization": "Организација",
        "secPersonal": "Лично",
        "secSettings": "Преферени поставки",
        "title": "Лични информации"
      },
      "postPwSet": {
        "info": "Сега можете да ја користите вашата нова лозинка.",
        "link_name": "Продолжи кон Self-Service",
        "link_url": "/user/ui/",
        "title": "Вашата лозинка е променета"
      },
      "resetPW": {
        "title": "Ресетирајте ја вашата лозинка"
      },
      "security": {
        "2fa": {
          "availableMethods": "Достапни 2FA методи:",
          "info": "Двофакторската автентикација (2FA) е безбедносна функција која додава дополнителен слој заштита на вашата сметка. Потребно е да користите две методи за најава, наместо само корисничко име и лозинка.",
          "method": {
            "email": "Е-пошта",
            "emailDesc": "Добивајте еднократни кодови преку е-пошта за да ги завршите барањата за автентикација.",
            "oath": {
              "add": {
                "button": "Регистрирај Authenticator апликација"
              }
            }
          }
        },
        "authenticator": "Authenticator апликација",
        "infoFederatedAccount": "Оваа сметка се управува од давателот на идентитет на вашата организација, па затоа лозинката не може да се промени овде. За да ја промените лозинката, најавете се преку страницата за најавување на вашата организација или контактирајте го вашиот IT администратор.",
        "lastUse": "Последно користено на {0}.",
        "msg": {
          "invalidPassword": "Внесената тековна лозинка не е валидна.",
          "passwordAlreadyUsed": "Не може повторно да се користат последните 5 лозинки.",
          "pwUpdateError": "Настана грешка при обид за промена на лозинката.",
          "pwUpdated": "Лозинката е променета."
        },
        "noDevice": "Не е конфигурирано",
        "oathAdd": {
          "appInfo": "За полесно најавување во STIHL, можете да користите Authenticator апликации како {0}, {1}, {2} и др., за да генерирате еднократни лозинки што се користат како втор фактор при најавувањето.<br/>Ако го изгубите или заборавите вашиот мобилен уред, секогаш можете да го користите 2FA кодот испратен по е-пошта.<br/><br/>Следете ги упатствата подолу за да го конфигурирате вашиот уред за автентикација.",
          "badCode": "Невалиден код, обидете се повторно.",
          "error": "Настана грешка при обид за регистрација на уредот за автентикација.",
          "headScan": "1. Скенирајте го QR-кодот со вашата Authenticator апликација",
          "headVerify": "2. Потврдете го кодот",
          "infoKey": "клуч за поставување",
          "infoKeyTitle": "Вашата двофакторска тајна",
          "infoScanBottom": "Не можете да скенирате? Можете да го користите {0} за рачно да ја конфигурирате вашата Authenticator апликација.",
          "infoVerify": "Внесете го кодот генериран од вашата Authenticator апликација.",
          "success": "Вашиот уред за автентикација е регистриран. Сега можете да го користите за најавување.",
          "title": "Регистрирајте го вашиот уред за двофакторска автентикација"
        },
        "oathDelete": {
          "error": "Настана грешка при обид за бришење на уредот за автентикација.",
          "success": "Уредот за автентикација е избришан."
        },
        "passkeys": {
          "about": {
            "info1": "Passkey се парови криптографски клучеви (јавен и приватен клуч) што ги чува автентикатор под ваша контрола. Автентикаторот може да докаже дека корисникот е присутен и е овластен да го користи passkey. Автентикаторите докажуваат овластување со PIN, код, биометрија или лозинка на уред, зависно од нивните можности и конфигурација. Автентикатори постојат во многу форми – iPhone или Android уред, Windows Hello, FIDO2 хардверски безбедносен клуч или менаџер на лозинки.",
            "info2": "Кога се најавувате во STIHL со passkey, вашиот автентикатор користи криптографија со јавен клуч за да го докаже вашиот идентитет пред STIHL, без никогаш да го испраќа самиот passkey. Passkey се врзани за домен на веб-страница, како stihl-sso.com, и бараат безбеден конекција, што значи дека прелистувачот ќе одбие автентикација на лажна фишинг-страница. Овие својства ги прават passkey многу отпорни на фишинг и значително потешки за напад од SMS или TOTP 2FA, кои можат да бидат измамени.",
            "info3": "Cloud-услугите за passkey дозволуваат клучевите да се синхронизираат помеѓу уреди (како Apple, Android или менаџери на лозинки), за да можат да се користат на повеќе места и потешко да се изгубат. Откако ќе конфигурирате синхронизиран passkey на еден уред, тој ќе биде достапен на повеќе уреди што ја користат истата услуга. На пример, ако регистрирате passkey со вашиот iCloud профил користејќи Touch ID на вашиот MacBook, потоа можете да го користите тој passkey со лице, отпечаток, PIN или лозинка на уред на повеќе уреди поврзани со истиот iCloud профил.",
            "title": "За Passkeys"
          },
          "add": {
            "button": "Додај нов Passkey",
            "error": "Настана грешка при додавање на нов passkey.",
            "success": "Додаден е нов passkey."
          },
          "delete": {
            "button": "Избриши Passkey",
            "error": "Настана грешка при бришење на овој passkey.",
            "success": "Passkey е избришан."
          },
          "edit": {
            "error": "Настана грешка при зачувување на името на passkey.",
            "name": "Име на Passkey",
            "success": "Името на passkey е ажурирано.",
            "title": "Дајте му име на вашиот passkey за да го разликувате од другите"
          },
          "info": "Passkey е едноставна и безбедна алтернатива на лозинките, која ја потврдува вашата идентификација со допир, препознавање лице, лозинка на уред или PIN.",
          "none": "Нема конфигурирани Passkey.",
          "reallyDelete": "Дали сте сигурни дека сакате да го избришете Passkey?",
          "registeredPasskeys": "Вашите регистрирани Passkey:",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "Дали сте сигурни дека сакате да го избришете уредот за автентикација?",
        "secMFA": "Двофакторска автентикација",
        "secPwdChange": "Промени лозинка",
        "title": "Безбедност"
      },
      "setPW": {
        "acceptTC": "Потврдете ги нашите {terms} и прочитајте ја нашата {privacy}.",
        "killSSO": "Поништи ги сите активни сесии",
        "msg": {
          "tokenExpired": "Линкот или кодот за лозинка е истечен. Следете ја врската за да ја ресетирате вашата лозинка: {link}."
        },
        "privacy": "Политика за приватност на податоци",
        "terms": "Услови и одредби",
        "title": "Внесете нова лозинка"
      }
    },
    "validations": {
      "hasDigit": "Мора да содржи цифра(и)",
      "hasLowercase": "Мора да содржи мали букви",
      "hasSpecial": "Мора да содржи специјални знаци: {chars}",
      "hasUppercase": "Мора да содржи големи букви",
      "invalidCharacters": "Содржи неважечки знаци",
      "maxLength": "Дозволени се најмногу {max} знаци",
      "minLength": "Потребни се најмалку {min} знаци",
      "notSameAsEmail": "Премногу слично на адресата за е-пошта",
      "onlyValidCharactersAllowed": "Дозволени се само букви, броеви и празни места.",
      "required": "Задолжително поле",
      "sameAsPassword": "Лозинките не се совпаѓаат",
      "tcAccepted": "Потврдете ги нашите услови и одредби.",
      "validEmail": "Невалидна адреса за е-пошта.",
      "validOTP": "Внесете го кодот за потврда."
    }
  }
}
